import React from 'react';
import {Helmet} from "react-helmet";

import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';

import AppConstants from 'AppConstants';

const AppName = <b>{AppConstants.APP_NAME}</b>;
const SITE_URL = <b>{AppConstants.WEBSITE}</b>

const PrivacyPolicy = <div>
	<h2>Privacy Policy Statement</h2>
	<p>The collection and retention of user{"'"}s personal information will be used to authenticate user from programmed bot. 
		And is used when user want to purchase a product or upload a design in {SITE_URL}. The user information will not be disseminated to others.</p>
	<p>User contact information, however, including the delivery address and contact number will be made available to the delivery personnel 
		and respective designers whose ArtWork was purchased by the user.</p>
</div>


const TermsAndConditions = <div>

	<h2>Seto Canvas Terms and conditions</h2>

	<p>Please read these Terms of Service completely before using {SITE_URL} which is owned and operated by {AppName}. This Agreement documents the legally binding terms and conditions attached to the use of the Site {SITE_URL}.</p>

	<p>By using the Site, a designer, herein known as the "Artist", agrees to the following Terms of Service. 
	The work of the Artist will be referred to as the "Artwork" in this document.</p>

	<p>By submitting the Artwork to {AppName}, the Artist accepts the following terms and conditions:</p>

	<h4><b>{AppConstants.APP_NAME} will:</b></h4>

	<ul>
		<li>Provide its expertise on designing (if need be), marketing, and promotion of the Artwork.</li>
		<li>Manufacture, distribute, and sell the Artwork on merchandises.</li>
		<li>Manage the inventory and bear all the cost and risk associated with it.</li>
		<li>Promote the Artwork under the co-branding of Seto Canvas and the Artist’s chosen brand name.</li>
		<li>Communicate and consult with the Artist to settle the final look of the Artwork on the planned merchandises.</li>
	</ul>

	<h4><b>Artist will:</b></h4>

	<ul>
		<li>Be an active member of {AppConstants.APP_NAME} community and provide the Artwork(s).</li>
		<li>Give {AppConstants.APP_NAME} his/her guarantee that the submitted Artwork(s) will be his/her original work.</li>
		<li>When given any project assignment by {AppConstants.APP_NAME}, the Artist will respect the requirements and timeline and fulfill their assigned responsibilities.</li>
		<li>Be responsible for the payment of any tax that arises as a result of receiving any payment from {AppConstants.APP_NAME} and/or any of its partners.</li>
		<li>Promote his/her association with {AppConstants.APP_NAME} through social media and any other channels that Artist finds suitable.</li>
	</ul>

	<h4><b>Artwork:</b></h4>

	<ul>
		<li>The Artist will maintain the ownership of the Artwork. {AppConstants.APP_NAME} will not claim ownership of any Artworks submitted to the platform.</li>
		<li>The Artwork will not infringe any rights of the third party.</li>
		<li>In any case of such copyright infringement, {AppConstants.APP_NAME} holds the right to reject Artwork and/or terminate this contract with the Artist, depending on the frequency of such infringement.</li>
		<li>The Artwork must not disparage any person; it must not be indecent, obscene, hateful, tortious, untruthful, inaccurate, defamatory, slanderous or libelous; it must not promote bigotry, racism, hatred or harm against any group or individual or promote discrimination based on race, gender, religion, nationality, disability, sexual orientation or age.</li>
		<li>By submitting the Artwork, the Artist hereby grants {AppConstants.APP_NAME} a worldwide, irrevocable, <b>EXCLUSIVE</b>, right and license to use, upload, modify, reproduce, copy, exhibit, distribute, sell, advertise, and display the Artwork, in any manner now known or hereafter devised.</li>
		<li>The Artist also grants {AppConstants.APP_NAME} a worldwide, irrevocable, non-exclusive, right and license to use, portray, display and publish your name, appearance, voice, likeness, photographic image, and biographical information alongside the Artwork, in any and all media now known or hereafter devised.</li>
		<li>{AppConstants.APP_NAME} reserves all the rights to include the Artworks in miscellaneous items such as, but not limited to calendars, posters, books, banners, etc. to promote {AppConstants.APP_NAME}, its community, and the Artist. If the Artist has any moral reservations for such, you can request it to <b>{AppConstants.CONTACT_EMAIL}</b></li>
		<li>In any circumstances, where you need to revoke the license provided to the {AppConstants.APP_NAME}, you can do so by sending a revoke request to <b>{AppConstants.CONTACT_EMAIL}</b></li>
	</ul>

	<br />

	<p>{AppName} reserves the right to modify these Terms of Service at any time. We do so by posting and drawing attention to the updated terms on the Site. Your decision to continue to visit and make use of the Site after such changes have been made constitutes your formal acceptance of the new Terms of Service.</p>
	<p>Therefore, we ask that you check and review this Agreement for such changes on an occasional basis. Should you not agree to any provision of this Agreement or any changes we make to this Agreement, we ask and advise that you do not use or continue to access the {AppName} site immediately.</p>

	<h2>Account Termination</h2>
	<p>{AppName} reserves the right to terminate your access to the Site, without any advance notice.</p>

	<h2>Contact Information</h2>
	<p>If you have any questions about this Agreement, please feel free to contact us at <b>{AppConstants.CONTACT_EMAIL}</b>.</p>
</div>




class AgreementsPage extends React.Component {

	render() {
		return (
				<div>
					<Helmet>
						<title>Terms & conditions - Privacy Policy | Seto Canvas</title>
					</Helmet>
					<HeaderContainer />		
						<div className="scWidth">
							{PrivacyPolicy}
							{TermsAndConditions}
						</div>
					<Footer />
				</div>
			);
		
	}
}

export default AgreementsPage;




// WEBPACK FOOTER //
// ./src/pages/docs/AgreementsPage.js